import { render, staticRenderFns } from "./UCourseCard.vue?vue&type=template&id=2a5f478e&scoped=true&"
import script from "./UCourseCard.vue?vue&type=script&lang=js&"
export * from "./UCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./UCourseCard.vue?vue&type=style&index=0&id=2a5f478e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f478e",
  null
  
)

export default component.exports